var jade = require("/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div class=\"modal-body\"><kofi-uebersicht antrag=\"extras.obj\"></kofi-uebersicht></div><div class=\"modal-footer\"><div class=\"form-footer\"><div class=\"required\"></div><div class=\"form-actions\"><button ng-click=\"exit()\" ng-disabled=\"loading\" role=\"button\" class=\"btn btn-default\"><span>Schließen</span></button></div></div></div>");;return buf.join("");
}